import { Button } from "ui/components/Button/Button";
import { ButtonLink } from "ui/components/Button/ButtonLink";
import { transformRoute, useTranslate } from "helpers";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { VehicleDocumentHeaderProps } from "./types";

const VehicleDocumentHeader = ({
    vehicleId,
    onAdd,
}: VehicleDocumentHeaderProps) => {
    const { t } = useTranslate();

    return (
        <div className="flex items-center gap-2">
            <ButtonLink
                size="small"
                variant="warning"
                children={t("admin.fleet.vehicle.document.detail")}
                to={transformRoute(
                    FleetVehicleRoutes.FleetVehicleDocumentSearchPageRouter,
                    {
                        id: vehicleId,
                    }
                )}
                startIcon="/media/icons/search.svg"
                
            />
            <Button
                size="small"
                variant="secondary"
                startIcon="/media/icons/plus.svg"
                onClick={onAdd}
            >
                {t("admin.fleet.vehicle.document.add")}
            </Button>
        </div>
    );
};

export default VehicleDocumentHeader;
